module.exports = __webpack_public_path__ + "static/media/farmer.7b0e97ed.jpg";